module.exports = "<p>\r\n  stock-historico works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/stock-historico/stock-historico.component.html
// module id = ../../../../../src/app/components/stock-historico/stock-historico.component.html
// module chunks = main